import { render, staticRenderFns } from "./SettingsStaff.vue?vue&type=template&id=2b481a57&"
import script from "./SettingsStaff.vue?vue&type=script&lang=js&"
export * from "./SettingsStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports